//
//
//
//
//
//
//
//
//
//
//



import UMUM from '../library/umum'

export default {

  props: ["list_penerima_final"],
  data() {
      return {
          UMUM: UMUM
      }
  },

}
